import { useEffect,createContext,useState, useCallback, useRef } from "react";
import { initialDane, initialKsiegowosc, initialProcesy } from "utils/initialvalue";

import { initialProdukty,initialElementy,initialFragmenty, initialOprawa, initalPakowanie } from "utils/initialvalue";
export const ModalInsertContext = createContext();
export const ModalInsertContextProvider = ({children})=>{
    const [openModalInsert, setOpenModalInsert] = useState(false);
  
    const [lockDragDrop, setLockDragDrop] = useState(false);
    const [isSaveButtonDisabled, setSaveButtonDisabled] = useState(true);

  const [isShowAddClientStage, showAddClientStage] = useState(false);
    const [showElementyProcesyInsert, setShowElementyProcesyInsert] =     useState(false);
    const [selectedElementROW,setSelectedElementROW] = useState(null)
    const [selectedZamowienie,setSelectedZamowienie] = useState({id:1})



    const [historiaZamowienia, setHistoriaZamowienia] = useState([]);  
    const [daneZamowienia, setDaneZamowienia] = useState(initialDane);  
    const [produkty, setProdukty] = useState(initialProdukty);
    const [elementy, setElementy] = useState(initialElementy);
    const [fragmenty, setFragmenty] = useState(initialFragmenty);
    const [oprawa, setOprawa] = useState(initialOprawa);
    const [pakowanie, setPakowanie] = useState(initalPakowanie);
    const [procesyElementow, setProcesyElementow] = useState(initialProcesy);
    const [procesyElementowTemporary, setProcesyElementowTemporary] = useState(initialProcesy);
    const [technologieID, setTechnologieID] = useState(null); // nr id technologi wygenerowanych zamówienia

    
    // procesy_produktow  - view_procesy_produktow
    const [procesyProduktow, setProcesyProduktow] = useState([]);
    const [procesyProduktowTemporary, setProcesyProduktowTemporary] = useState([]);
    const [showProcesyProduktow, setShowProcesyProduktow] =     useState(false);
    const [selectedOprawaRow,setSelectedOprawaRow] = useState(null)


    const [kosztyDodatkoweZamowienia, setKosztyDodatkoweZamowienia] = useState([]);
    const [ksiegowosc, setKsiegowosc] = useState(initialKsiegowosc);
    const [faktury, setFaktury] = useState([]);
    const [zamowienieProgres, setZamowienieProgres] = useState([]); 


  

    const [selectedKosztyDodatkoweZamowienia,setSelectedKosztyDodatkoweZamowienia] = useState(null)

    const [showPaperStage, setShowPaperStage] =useState(false);
    const [showInputNrZamowienie, setShowInputNrZamowienie] =useState(false);
    const [showMenuZamowienia, setShowMenuZamowienia] = useState(false);
  const [showTabs, setShowTabs] = useState({parametry:true,koszty:false,historia:false,faktury:false,kreator: false});
  

    const harmonogramRef = useRef(false); 
     
  // useEffect(() => {

  //   setDaneZamowienia({...daneZamowienia, etap: showTabs.harmonogram? 1:2})
  //   // if (showTabs.harmonogram) {
  //   //   // Aktualizujemy stan w kontekście na 1
  //   //   // setDaneZamowienia(prev => ({ ...prev, etap: 1}));
  //   //   // setDaneZamowienia(prev => ({ ...prev, etap: 1}));
  //   //         setDaneZamowienia({...daneZamowienia, etap:1})
  //   //   // setDaneZamowienia(prev => ({ ...prev, etap: 2}));


  //   // }else{
  //   //   // setDaneZamowienia(prev => ({ ...prev, etap: 2}));
  //   //         setDaneZamowienia({...daneZamowienia, etap:2})


  //   // }
  // }, [showTabs.harmonogram]);

    
    useEffect(() => {
     


      setSaveButtonDisabled(true)
    }, [daneZamowienia,produkty,elementy,fragmenty,oprawa,procesyElementow,procesyElementowTemporary]);

  
    
     const addHistoria = (row) => {
      const new_historia = historiaZamowienia.splice()
      new_historia.push(row)
      // const his = historiaZamowienia.push({id:1})
       setHistoriaZamowienia(new_historia)
      // console.log(row)
    };

function handleKosztyDodatkoweZamowienia(koszt) {
  let koszty = kosztyDodatkoweZamowienia.map((t) => {
    if (t.id == koszt.id) {
      return koszt;
    } else {
      return t;
    }
  });
  let suma = koszty
    .filter((x) => x.delete != true)
    .map((x) => parseFloat(x.suma.replace(/,/g, ".")))
    .reduce((a, b) => a + b, 0)
    .toFixed(2);
  setKsiegowosc({ ...ksiegowosc, koszty_wartosc: suma, update: true });
  setKosztyDodatkoweZamowienia(koszty);

let skonto =((parseFloat(daneZamowienia.skonto) || 0) / 100 )
let wartosc_koncowa =(parseFloat(daneZamowienia.wartosc_zamowienia) || 0) + (parseFloat(suma) || 0 )
            setDaneZamowienia({
              ...daneZamowienia,       
              cena_z_kosztami: (((parseFloat(suma) || 0) + (parseFloat(daneZamowienia.wartosc_zamowienia) || 0)) / (produkty[0].naklad || 1)).toFixed(2),
wartosc_koncowa: (wartosc_koncowa - (wartosc_koncowa * skonto)).toFixed(2),
              // status: daneZamowienia.stan == 3 ? 3 : daneZamowienia.status,
              update: true,

            });


}




                            function handleFaktury(faktura) {

let fak = faktury.map((t) => {
                  if (t.id == faktura.id) {
                    return faktura;
                  } else {
                    return t; 
                  }

                })
    // if(fak.filter(x=>x.delete != true).length ==0 ){
    //               setKsiegowosc({...ksiegowosc, faktury_status:1, update:true})
    //             }
    
   let  suma = fak.filter(x=>x.delete != true).map(x => parseFloat( x.suma.replace(/,/g, '.'))).reduce((a, b) => a + b, 0).toFixed(2)

   if(fak.filter(x=>x.delete != true).length ==0 ){
setKsiegowosc({...ksiegowosc, faktury_wartosc:suma,faktury_status:1, update:true})
   }else{
setKsiegowosc({...ksiegowosc, faktury_wartosc:suma, update:true})   
   }
                // setKsiegowosc({...ksiegowosc, faktury_wartosc:suma, update:true})

              setFaktury(fak     );

              }


     
     // aktualizacja row w stanie produkty, elementy, fragmenty, oprawa, pakowanie
      const handleUpdateRowProdukty = (row) => {
      setProdukty(
        produkty.map((t) => {
          if (t.id === row.id) {
            return row;
          } else {
            return t;
          }
        })
      )

        // setDaneZamowienia({...daneZamowienia, naklad:row.naklad,wartosc_zamowienia:1});




    };


          const handleUpdateDane = (dane) => {
            setDaneZamowienia(dane);

    };

    const handleUpdateRowElementy = (row) => {
      setElementy(
        elementy.map((t) => {
          if (t.id === row.id) {
            return row;
          } else {
            return t;
          }
        })
      )
       
    };

    const handleUpdateRowFragmenty = (row) => {
      setFragmenty(
        fragmenty.map((t) => {
          if (t.id === row.id) {
            return row;
          } else {
            return t;
          }
        })
      )
       
    };

    function handleChangeCardFragmenty_i_Elementy_naklad(card) {
      // zmienia typ fragmentów gdy typ elementu jest zmieniany
      setElementy(
        elementy.map((t) => {
          if (t.id === card.id) {
            return card;
          } else {
            return t;
          }
        })
      );
  
      setFragmenty(
        fragmenty.map((t, a) => {
        // console.log("oprawa id" +prev)
        if (t.element_id === card.id) {
          return {
            ...t,
            naklad: card.naklad,
            update:true
  
          };
        } else {
          return t;
        }
      })
    );
    }

    function handleChangeCardFragmenty_i_Elementy_nazwa(card) {
      // zmienia typ fragmentów gdy typ elementu jest zmieniany
      setElementy(
        elementy.map((t) => {
          if (t.id === card.id) {
            return card;
          } else {
            return t;
          }
        })
      );
  
      setFragmenty(
        fragmenty.map((t, a) => {
        // console.log("oprawa id" +prev)
        if (t.element_id === card.id) {
          return {
            ...t,
            wersja: card.nazwa,
            update:true
  
          };
        } else {
          return t;
        }
      })
    );
    }



    const handleUpdateRowOprawa = (row) => {
      setOprawa(
        oprawa.map((t) => {
          if (t.id === row.id) {
            return row;
          } else {
            return t;
          }
        })
      )
       
    };

    const handleUpdateRowPakowanie = (row) => {
      setPakowanie(
        pakowanie.map((t) => {
          if (t.id === row.id) {
            return row;
          } else {
            return t;
          }
        })
      )
    };

    const handleUpdateRowProcesyElementow = (row) => {
      setProcesyElementowTemporary(
        procesyElementowTemporary.map((t) => {
          if (t.id == row.id) {
            return row;
          } else {
            return t;
          }
        })
      )
       
    };










    
    return (
      <ModalInsertContext.Provider
        value={{
          openModalInsert, setOpenModalInsert,
          daneZamowienia, setDaneZamowienia,
          produkty, setProdukty,
          elementy, setElementy,
          fragmenty, setFragmenty,
          oprawa, setOprawa,
          pakowanie, setPakowanie,
          procesyElementow, setProcesyElementow,
          procesyElementowTemporary, setProcesyElementowTemporary,
          kosztyDodatkoweZamowienia, setKosztyDodatkoweZamowienia,
          technologieID, setTechnologieID,
zamowienieProgres, setZamowienieProgres,
          lockDragDrop, setLockDragDrop,
     
          selectedElementROW,
          setSelectedElementROW,
          showElementyProcesyInsert,
          setShowElementyProcesyInsert,
          isSaveButtonDisabled, setSaveButtonDisabled,
          handleUpdateRowProdukty,
          handleUpdateRowElementy,
          handleUpdateRowFragmenty,
          handleUpdateRowPakowanie,
          handleUpdateRowOprawa,
          handleUpdateRowProcesyElementow,
    
      
        
          selectedKosztyDodatkoweZamowienia,setSelectedKosztyDodatkoweZamowienia,showPaperStage, setShowPaperStage,
          selectedZamowienie,setSelectedZamowienie,isShowAddClientStage, showAddClientStage,addHistoria,historiaZamowienia, setHistoriaZamowienia,
          showInputNrZamowienie, setShowInputNrZamowienie,
          showMenuZamowienia, setShowMenuZamowienia,
          handleChangeCardFragmenty_i_Elementy_naklad,
          handleChangeCardFragmenty_i_Elementy_nazwa,
          showTabs, setShowTabs,
          ksiegowosc, setKsiegowosc,handleKosztyDodatkoweZamowienia,
          faktury, setFaktury,handleFaktury,
          procesyProduktow, setProcesyProduktow,procesyProduktowTemporary, setProcesyProduktowTemporary,
          showProcesyProduktow, setShowProcesyProduktow,selectedOprawaRow,setSelectedOprawaRow,
      handleUpdateDane,
      harmonogramRef



          

        }}
      >
        {children}
      </ModalInsertContext.Provider>
    );
}